export const createEmployee = async (idToken, employeeDetails) => {
  const response = await fetch(`${process.env.REACT_APP_BASE_URL}/employee`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${idToken}`,
    },
    mode: "cors",
    body: JSON.stringify({
      body: employeeDetails,
    }),
  });

  if (!response.ok) {
    console.log("Error");
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  const data = await response.json();
  return data;
};
